var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModalAcessoPerfis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7492 13.6947C15.9618 12.8416 15.0063 12.1608 13.9428 11.6951C12.8794 11.2295 11.7311 10.9891 10.5701 10.9891C9.40922 10.9891 8.26087 11.2295 7.19743 11.6951C6.13399 12.1608 5.17849 12.8416 4.39112 13.6947C4.26955 13.8291 4.20155 14.0035 4.20001 14.1847V17.1248C4.20259 17.318 4.28116 17.5024 4.41873 17.6382C4.55629 17.7739 4.74178 17.85 4.93503 17.85H16.2053C16.4002 17.85 16.5871 17.7725 16.725 17.6347C16.8628 17.4968 16.9403 17.3099 16.9403 17.115V14.1749C16.9364 13.9971 16.8685 13.8266 16.7492 13.6947Z",
    fill: "#34639C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5701 10.0102C12.4645 10.0102 14.0002 8.47447 14.0002 6.58009C14.0002 4.68572 12.4645 3.15002 10.5701 3.15002C8.67571 3.15002 7.14001 4.68572 7.14001 6.58009C7.14001 8.47447 8.67571 10.0102 10.5701 10.0102Z",
    fill: "#34639C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalAcessoPerfis);
export default __webpack_public_path__ + "static/media/IconModalAcessoPerfis.fca2fb4aaed2bb7107b5290eb14f3e88.svg";
export { ForwardRef as ReactComponent };